import { routeName } from './routeName';
/**
 * window popup의 id를 관리한다.
 */
export const popupIdData = {
    /** 출발도착관제 팝업 */
    [routeName.LOCATION_CONTROL]: {
        id: 'popup-location-control',
        position: 'center',
        width: 500,
        height: 800,
    },
    /** 라이더 배차 팝업 */
    [routeName.WORKER_ALLOCATE]: {
        id: 'popup-worker-allocate',
        position: 'center',
        width: 500,
        height: 800,
    },
    /** 출금요청 팝업 */
    [routeName.WITHDRAWAL_REQUEST]: {
        id: 'popup-withdrawal-request',
        position: 'center',
        width: 500,
        height: 800,
    },
    /** 라이더 상세정보 팝업 */
    [routeName.WORKER_DETAIL]: {
        id: 'popup-worker-detail',
        position: 'right-bottom',
        width: 1200,
        height: 800,
    },
};
